<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        d="M19.2806 11.0312C19.2109 11.1009 19.1282 11.1563 19.0371 11.194C18.9461 11.2318 18.8485 11.2512 18.7499 11.2512C18.6514 11.2512 18.5538 11.2318 18.4627 11.194C18.3717 11.1563 18.289 11.1009 18.2193 11.0312L12.7499 5.5609V20.2506C12.7499 20.4495 12.6709 20.6403 12.5303 20.7809C12.3896 20.9216 12.1988 21.0006 11.9999 21.0006C11.801 21.0006 11.6103 20.9216 11.4696 20.7809C11.3289 20.6403 11.2499 20.4495 11.2499 20.2506V5.5609L5.78055 11.0312C5.63982 11.1719 5.44895 11.251 5.24993 11.251C5.05091 11.251 4.86003 11.1719 4.7193 11.0312C4.57857 10.8905 4.49951 10.6996 4.49951 10.5006C4.49951 10.3016 4.57857 10.1107 4.7193 9.96996L11.4693 3.21996C11.539 3.15023 11.6217 3.09491 11.7127 3.05717C11.8038 3.01943 11.9014 3 11.9999 3C12.0985 3 12.1961 3.01943 12.2871 3.05717C12.3782 3.09491 12.4609 3.15023 12.5306 3.21996L19.2806 9.96996C19.3503 10.0396 19.4056 10.1223 19.4433 10.2134C19.4811 10.3044 19.5005 10.402 19.5005 10.5006C19.5005 10.5992 19.4811 10.6967 19.4433 10.7878C19.4056 10.8788 19.3503 10.9616 19.2806 11.0312Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
